import React, { useContext, createContext } from "react";
import axiosFactory, { METHOD_POST } from "../helpers/AxiosFactory";
import {
  GET_ALL_PUBLISHED_BLOGS,
  GET_BLOG_BY_ID,
  GET_BLOGS_BY_FILTERS,
  GET_BLOG_SIBLINGS,
  GET_BLOG_RELATED,
  GET_BLOG_CATEGORY,
  GET_BLOG_CATEGORIES,
} from "../helpers/UrlConstants";
const BlogContext = createContext();
export function useBlogContext() {
  return useContext(BlogContext);
}
export default function BlogProvider({ children }) {
  async function getAllPublishedBlogs(limit) {
    return await axiosFactory({
      url: GET_ALL_PUBLISHED_BLOGS,
      method: METHOD_POST,
      data: limit,
    });
  }
  async function getBlogsById(data) {
    return await axiosFactory({
      url: GET_BLOG_BY_ID,
      method: METHOD_POST,
      data: data,
    });
  }
  async function getBlogsByFilter(data) {
    return await axiosFactory({
      url: GET_BLOGS_BY_FILTERS,
      method: METHOD_POST,
      data: data,
    });
  }
  // Internal links (src/seo/content.js on the API).
  async function getBlogSiblings(data) {
    return await axiosFactory({ url: GET_BLOG_SIBLINGS, method: METHOD_POST, data });
  }
  async function getBlogRelated(data) {
    return await axiosFactory({ url: GET_BLOG_RELATED, method: METHOD_POST, data });
  }
  async function getBlogCategory(data) {
    return await axiosFactory({ url: GET_BLOG_CATEGORY, method: METHOD_POST, data });
  }
  async function getBlogCategories(data) {
    return await axiosFactory({ url: GET_BLOG_CATEGORIES, method: METHOD_POST, data });
  }
  const value = {
    getAllPublishedBlogs,
    getBlogsById,
    getBlogsByFilter,
    getBlogSiblings,
    getBlogRelated,
    getBlogCategory,
    getBlogCategories,
  };
  return <BlogContext.Provider value={value}>{children}</BlogContext.Provider>;
}
